import React from 'react';

interface DocumentTextProps {
    fill?: string;
    secondaryfill?: string;
    width?: string;
    height?: string;
    style?: React.CSSProperties;
    className?: string; // Ajout de la prop className
}

const DocumentText: React.FC<DocumentTextProps> = ({ fill = 'currentColor', width = '100%', height = '100%', style, className }) => {
    return (
        <svg height={height} width={width} style={style} className={className} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg">
            <g fill={fill}>
                <defs />
                <path className="cls-1" d="M782.17 915H277.83c-20.2 0-36.58-16.38-36.58-36.58V181.58c0-20.2 16.38-36.58 36.58-36.58h277.35c145.57 0 263.57 118 263.57 263.57v469.85c0 20.2-16.38 36.58-36.58 36.58z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
                <path className="cls-1" d="M555.18 433.75h263.57v-25.18C818.75 263 700.75 145 555.18 145v288.75z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
                <path className="cls-1" d="M336.5 608h372" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
                <path className="cls-1" d="M336.5 732h248" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
            </g>
        </svg>
    );
};

export default DocumentText;
